import PropTypes from "prop-types";
import Modal from "react-modal";
import "./FlightDetailModal.scss";
import Itinerary from "app/pages/.shared/Itinerary";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { useSelector } from "react-redux";
import { getMaxLuggageCount } from "app/pages/Booking/bookingSelectors";
import { selectDefaultFlightBaggage } from "app/utils/bookingUtils";
import QuotationLuggage from "app/pages/Booking/Quotation/Luggage/QuotationLuggage";
import { useContext } from "react";
import appGlobalsContext from "app/AppGlobalsContext";
import { BRANDS } from "app/constants";
import { getSupplierClass } from "app/utils/utils";
import findLast from "lodash/findLast";
import { CrossIcon } from "app/icons/navigation";
import { IdeaStrokeIcon } from "app/icons/profile";
import { ICON_SIZES } from "app/constants";

Modal.setAppElement("#perfectstay");

const FlightDetailModal = ({ isOpened, close, flight = {}, isStopOver = false }) => {
	const { brand } = useContext(appGlobalsContext);
	const luggageMaxCount = useSelector(getMaxLuggageCount);
	// on EK and TK we don't show luggage summary in flight details modal because backend return 46kg instead of 23kg
	const hideLuggageSummary = brand === BRANDS.EK || brand === BRANDS.TK;

	const defaultFlightBaggage = selectDefaultFlightBaggage({
		flightOptions: flight?.flightOptions,
		passengersCount: luggageMaxCount,
	});

	const isBaggageIncluded = flight?.flightOptions?.flightBagageOption?.included;

	const hasFreeBaggage = findLast(
		flight?.flightOptions?.flightBagageOptions,
		option => option?.pricePerBooking === 0
	);

	// on utilise selectDefaultFlightBaggage pour avoir la même logique que lapage devis dans la sélection de bagages
	// cependant la différence est que l'on ne veut pas afficher le poids max des bagages si ceux ci ne sont pas inclus dans le tarif
	// et qu'il n'y a pas d'option de bagage gratuite
	if (!isBaggageIncluded && !hasFreeBaggage) {
		delete defaultFlightBaggage?.maxWeightPerBaggage;
	}

	if (!isOpened) {
		return false;
	}

	return (
		<Modal
			isOpen={isOpened}
			onRequestClose={close}
			className={classNames("flight-detail-modal", {
				"flight-detail-modal--stopover": isStopOver,
			})}
			overlayClassName="flight-detail-modal__overlay"
		>
			<div className="flight-detail-modal__flight">
				<div className="flight-detail-modal__close" onClick={close}>
					<CrossIcon size={ICON_SIZES.LG} />
				</div>
				<div className="flight-detail-modal__title">
					<Typography variant={TYPOGRAPHY_VARIANTS.XL} isBold>
						<FormattedMessage id="general.flight.detail" />
					</Typography>
				</div>
				<div className="flight-detail-modal__customizable-note">
					<IdeaStrokeIcon size={ICON_SIZES.XS} />
					<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR}>
						<FormattedMessage id="sdp.product.customization.note" />
					</Typography>
				</div>
				<Itinerary
					inbound={flight.inbound}
					outbound={flight.outbound}
					disableDetails={true}
					outboundSupplierClass={getSupplierClass(flight?.outbound?.legs)}
					inboundSupplierClass={getSupplierClass(flight?.inbound?.legs)}
				/>
				{!hideLuggageSummary && (
					<QuotationLuggage
						informativeOnly
						luggageMaxCount={luggageMaxCount}
						flightBagageOption={flight?.flightOptions?.flightBagageOption}
						flightBagageOptions={flight?.flightOptions?.flightBagageOptions}
						flightOptionsStatus={flight?.flightOptionsStatus}
						selectedCheckedBaggageOption={defaultFlightBaggage}
						selectedCabinBaggage={defaultFlightBaggage.cabinBaggage}
					/>
				)}
			</div>
		</Modal>
	);
};

FlightDetailModal.propTypes = {
	isOpened: PropTypes.bool,
	close: PropTypes.func,
	flight: PropTypes.object,
	isStopOver: PropTypes.bool,
};

export default FlightDetailModal;
